@if (mode === 'message') {
  <div class="success-message">
    <h3>Your application has been received!</h3>
    <mat-icon>check_circle</mat-icon>
    <p>You can log in and preview the site while we review your submission.</p>
  </div>
} @else {
  <div class="login-container">
    <h3>Apply for membership</h3>

    @if (mode === 'form') {
      <div class="form-container">

        <form [formGroup]="form">

          <div class="pb-12">
            <div class="custom-icon-input-container">
              <input type="text" formControlName="email" placeholder="Email address *">
              <mat-icon>mail</mat-icon>
            </div>

            @if (form.controls.email.touched) {
              <div class="alert">

                @if (form.controls.email.hasError('email')) {
                  <div class="form-validation-error">
                    Incorrect email
                  </div>
                }
                @if (form.controls.email.hasError('emailExists')) {
                  <div class="form-validation-error">
                    EmailExists
                  </div>
                }
              </div>
            }
          </div>


          <div class="pb-12">
            <div class="custom-icon-input-container">
              <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="password" placeholder="Password *" autocomplete="off">
              <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
            </div>
            @if (form.controls.password.touched) {
              <div class="alert">

                @if (form.controls.password.hasError('minlength')) {
                  <div class="form-validation-error">
                    Password should be at least 6 symbols long
                  </div>
                }
                @if (form.controls.password.hasError('pattern')) {
                  <div class="form-validation-error">
                    Password must contain at least one uppercase letter, one lowercase letter, one number and one special character
                  </div>
                }
              </div>
            }
          </div>

          <div class="pb-12">
            <div class="custom-icon-input-container">
              <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="passwordConfirm" placeholder="Password confirm *" autocomplete="off">
              <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
            </div>
            @if (form.controls.passwordConfirm.touched) {
              <div class="alert">

                @if (form.hasError('passwordMismatch')) {
                  <div class="form-validation-error">
                    Passwords should mach
                  </div>
                }
              </div>
            }
          </div>


          <app-user-data formControlName="userData" [performanceTypes]="performanceTypes"></app-user-data>

          <!--        @if (selectedPlanData) {-->
          <!--          <div class="pb-12">-->
          <!--            <button matButton="filled" class="button-regular w-100" (click)="showPlanSelectionDialog()">Selected Plan: {{selectedPlanData.product.name }} (${{selectedPlanData.monthly / 100}} / month)</button>-->
          <!--          </div>-->
          <!--        }-->

          <!--        <div class="pb-12">-->
          <!--          <div class="custom-icon-input-container">-->
          <!--            <input type="text" formControlName="promoCode" placeholder="Promo code">-->
          <!--          </div>-->
          <!--        </div>-->

          <div class="d-flex align-center">
            <mat-checkbox formControlName="newsSubscribe"></mat-checkbox>
            <div class="form-hint">
              By creating an account you accept our <a routerLink="/terms-and-conditions">Terms and Conditions</a>
              and <a routerLink="/privacy-policy">Privacy Policy</a>

            </div>

          </div>

          <div class="form-hint ml-12">
            <a href="https://djmixinglab.com">djmixinglab.com</a> is a curated music remixing platform created to elevate the
            performances of DJs. Every remix on the site is produced by professional DJs with the exclusive goal
            of enhancing live shows. By selecting “I Agree,” you confirm that you are an active DJ and that any material
            obtained from <a href="https://djmixinglab.com">djmixinglab.com</a> will be used solely to enhance your personal DJ
            performance. You further agree not to sell, resell, or redistribute any files from this website.
            By joining as a member of <a href="https://djmixinglab.com">djmixinglab.com</a>, you certify that the
            original works used in the remixed compositions are already in your possession.
          </div>

          <!--        @if (!selectedPlanId) {-->
          <!--          <div class="select-plan-hint">-->
          <!--            Please <a (click)="showPlanSelectionDialog()"> select </a> the subscription plan to proceed-->
          <!--          </div>-->

          <!--        }-->

          <button matButton="filled" class="button-regular w-100" [disabled]="form.invalid" (click)="save()">Apply Now</button>


          <div class="form-footer-block">
            <div class="form-hint">
              Already have an account?
              <a routerLink="/login">Login</a>
            </div>

          </div>


        </form>
      </div>
    } @else if (mode === 'loading') {
      <div class="form-container">
        <div class="d-flex justify-around">
          <mat-spinner></mat-spinner>
        </div>
      </div>

    }
  </div>
}


